(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;
    const source = video.dataset.src;
    if (!source) return;
    video.src = source;
    video.dataset.loaded = 'true';
    video.load();
  };

  const initialise = (scope = document) => {
    const videos = Array.from(scope.querySelectorAll('[data-nura-ugc-video]')).filter(
      (video) => video.dataset.initialized !== 'true',
    );
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => {
        loadVideo(video);
        video.controls = reducedMotion.matches;
        if (!reducedMotion.matches) video.play().catch(() => {});
        video.dataset.initialized = 'true';
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            loadVideo(video);
            if (reducedMotion.matches) video.controls = true;
            else video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '280px 0px', threshold: 0.08 },
    );

    videos.forEach((video) => {
      video.dataset.initialized = 'true';
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
